const smallCards = [
  {
    title: "Total",
    total: "0",
    chart: {
      series: [
        {
          name: "Total",
          data:[],
          // data: [210, 180, 650, 200, 600, 100, 800, 300, 500],
        },
      ],
      options: {
        chart: {
          // width: 70,
          // height: 200,
          type: "bar",
          toolbar: {
            show: false,
          },
          dropShadow: {
            enabled: true,
            enabledOnSeries: undefined,
            top: 5,
            left: 0,
            blur: 3,
            color: "#16C7F9",
            opacity: 0.3,
          },
          zoom: {
            enabled: false,
          },
        },
        colors: ["#cff3ff"],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: 2,
          curve: "smooth",
        },
        grid: {
          show: false,
        },
        tooltip: {
          x: {
            show: false,
          },
          y: {
            show: false,
          },
          z: {
            show: false,
          },
          marker: {
            show: false,
          },
        },
        xaxis: {
          categories: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
          ],
          labels: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          tooltip: {
            enabled: false,
          },
        },
        yaxis: {
          min:1,
          labels: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
      },
    },
  },
  {
    title: "Helmet Module",
    total: "0",
    chart: {
      series: [
        {
          name: "Helmet Module",
          data:[],
          // data: [210, 180, 650, 200, 600, 100, 800, 300, 500],
        },
      ],
      options: {
        chart: {
          // width: 70,
          // height: 200,
          type: "bar",
          toolbar: {
            show: false,
          },
          dropShadow: {
            enabled: true,
            enabledOnSeries: undefined,
            top: 5,
            left: 0,
            blur: 3,
            color: "#16C7F9",
            opacity: 0.3,
          },
          zoom: {
            enabled: false,
          },
        },
        colors: ["#e1580e"],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: 2,
          curve: "smooth",
        },
        grid: {
          show: false,
        },
        tooltip: {
          x: {
            show: false,
          },
          y: {
            show: false,
          },
          z: {
            show: false,
          },
          marker: {
            show: false,
          },
        },
        xaxis: {
          // categories: [
          //   "Jan",
          //   "Feb",
          //   "Mar",
          //   "Apr",
          //   "May",
          //   "Jun",
          //   "Jul",
          //   "Aug",
          //   "Sep",
          // ],
          labels: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          tooltip: {
            enabled: false,
          },
        },
        yaxis: {
          forceNiceScale:true,
          min:0,
          max:undefined,
          labels: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
      },
    },
  },
  {
    title: "Emergency Exit",
    total: "0",
    chart: {
      series: [
        {
          name: "Emergency Exit",
          data:[]
          // data: [210, 180, 650, 200, 600, 100, 800, 300, 500],
        },
      ],
      options: {
        chart: {
          // width: 70,
          // height: 200,
          type: "bar",
          toolbar: {
            show: false,
          },
          dropShadow: {
            enabled: true,
            enabledOnSeries: undefined,
            top: 5,
            left: 0,
            blur: 3,
            color: "#16C7F9",
            opacity: 0.3,
          },
          zoom: {
            enabled: false,
          },
        },
        colors: ["#a6e9b0"],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: 2,
          curve: "smooth",
        },
        grid: {
          show: false,
        },
        tooltip: {
          x: {
            show: false,
          },
          y: {
            show: false,
          },
          z: {
            show: false,
          },
          marker: {
            show: false,
          },
        },
        xaxis: {
          categories: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
          ],
          labels: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          tooltip: {
            enabled: false,
          },
        },
        yaxis: {
          labels: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
      },
    },
  },
  {
    title: "Machine Guard",
    total: "0",
    chart: {
      series: [
        {
          name: "Machine Guard",
          data:[]
          // data: [210, 180, 650, 200, 600, 100, 800, 300, 500],
        },
      ],
      options: {
        chart: {
          // width: 70,
          // height: 200,
          type: "bar",
          toolbar: {
            show: false,
          },
          dropShadow: {
            enabled: true,
            enabledOnSeries: undefined,
            top: 5,
            left: 0,
            blur: 3,
            color: "#16C7F9",
            opacity: 0.3,
          },
          zoom: {
            enabled: false,
          },
        },
        colors: ["#e8d7a5"],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: 2,
          curve: "smooth",
        },
        grid: {
          show: false,
        },
        tooltip: {
          x: {
            show: false,
          },
          y: {
            show: false,
          },
          z: {
            show: false,
          },
          marker: {
            show: false,
          },
        },
        xaxis: {
          categories: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
          ],
          labels: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          tooltip: {
            enabled: false,
          },
        },
        yaxis: {
          labels: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
      },
    },
  },
];

export default smallCards;